<div class="ir-modal th-modal">
  <div class="ir-modal--title">
    <div class="ir-line--right">
      <div class="ir-btn th-btn-modal" (click)="cancel()"><i class="material-icons">close</i></div>
    </div>
    <div class="ir-line">
      <div class="ir-line-content">
        <span>{{ 'plugins.parts.partsview-modal.title' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="ir-modal--body has-footer">
    <parts-view style="font-size: 14px" [pageId]="0" [uid]="uid" [machineSerial]="machineSerial" (basketChange)="parts = $event"></parts-view>
  </div>
  <div class="ir-modal--footer ir-position--b th-modal--footer">
    <div class="ir-row">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
          <span>{{ 'common.cancel' | translate }}</span>
        </div>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <button class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right" (click)="submit()">
          <span>{{ 'plugins.parts.partsview-modal.submit' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
